import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { payoutService } from '../services/payout.service';
import type { CreatePayoutMethodData } from '../types/payout.types';
import { ONBOARDING_STATUS_KEY } from './use-onboarding-status';

export const PAYOUT_METHODS_KEY = ['seller', 'payout-methods'];

export function usePayoutMethods() {
  return useQuery({
    queryKey: PAYOUT_METHODS_KEY,
    queryFn: () => payoutService.getPayoutMethods(),
  });
}

export function useAddPayoutMethod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePayoutMethodData) => payoutService.addPayoutMethod(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PAYOUT_METHODS_KEY });
      queryClient.invalidateQueries({ queryKey: ONBOARDING_STATUS_KEY });
    },
  });
}

export function useUpdatePayoutMethod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<CreatePayoutMethodData> }) =>
      payoutService.updatePayoutMethod(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PAYOUT_METHODS_KEY });
    },
  });
}

export function useDeletePayoutMethod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => payoutService.deletePayoutMethod(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PAYOUT_METHODS_KEY });
      queryClient.invalidateQueries({ queryKey: ONBOARDING_STATUS_KEY });
    },
  });
}

export function useSetDefaultPayoutMethod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => payoutService.setDefaultPayoutMethod(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PAYOUT_METHODS_KEY });
    },
  });
}
